import { getCommunityDetailQueryKey } from '@pba/react-network';
import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { requestToJoinCommunity } from '../../services';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'There was an error sending request to join community');
};

export const useRequestToJoinCommunity = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, { id: string; reason?: string }>({
    defaultMutateOnError,
    async mutationFn({ id, reason }) {
      await requestToJoinCommunity({ body: { reason }, routeParams: { id } });
    },
    async onSettled(_data, _error, { id }) {
      await queryClient.invalidateQueries({ queryKey: getCommunityDetailQueryKey({ id }) });
    },
  });
};
